import { BookMinusMultipleIcon } from './BookMinusMultipleIcon';

/**
 * author: Perth Totty
 * id 6B536CF6-98D8-44A5-9094-43C1BE41EC91
 * name book-minus-multiple
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-minus-multiple.svg
 * tags
 */
export const BooksMinusIcon = BookMinusMultipleIcon;
export default BooksMinusIcon